import React, { HTMLAttributes, ReactNode } from "react";

export interface HeadingProps extends HTMLAttributes<HTMLHeadingElement> {
  fontClass?: string;
  desc?: ReactNode;
  isCenter?: boolean;
}

const Heading: React.FC<HeadingProps> = ({
  children,
  desc = "",
  className = "text-neutral-900 dark:text-neutral-50",
  isCenter = false,
  ...args
}) => {
  return (
    <div
      className={`nc-Section-Heading relative podcasts-divider ${className}`}
    >
     <div className="desktop-container">
  <h2
    className="font-mobile font-semibold whitespace-nowrap"
    {...args}
  >
    {children || "Section Heading"}
  </h2>

  <div className="grow h-[2px] bg-red-500" />
</div>
    </div>
  );
};

export default Heading;